import { render, staticRenderFns } from "./reclamo.vue?vue&type=template&id=237f55b2&scoped=true&"
import script from "./reclamo.vue?vue&type=script&lang=js&"
export * from "./reclamo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237f55b2",
  null
  
)

export default component.exports